import { useState } from 'react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'
import { classNames } from '@/utils/helpers'

import { ListContent } from './ListContent'
import type { ListsRequestConfig } from './ListHeading'
import { ListHeading } from './ListHeading'
import type { CollectionsItem } from './types'

type Props = ListsRequestConfig & {
  lists: CollectionsItem[]
  isLoading: boolean
  canLoadMore: boolean
  onLoadMore: () => void
  isFetchingNextPage: boolean
  onSelectListId: (listId: CollectionsItem['id']) => void
  className?: string
  onReorder: (origin: CollectionsItem, target: CollectionsItem) => void
  saveCustomOrderChanges: () => Promise<void>
  isCustomOrderChangeLoading: boolean
  openInCustomOrderEditMode: boolean
  isSortAndOrderDisabled: boolean
}

export const CollectionsList = ({
  query,
  setQuery,
  lists,
  isLoading,
  canLoadMore,
  onLoadMore,
  isFetchingNextPage,
  sort,
  order,
  setSort,
  setOrder,
  onSelectListId,
  onReorder,
  saveCustomOrderChanges,
  isCustomOrderChangeLoading,
  openInCustomOrderEditMode,
  className,
  isSortAndOrderDisabled,
  sortOptions,
  orderOptions,
}: Props) => {
  const [isCustomizeOrderModeActive, setIsCustomizeOrderModeActive] = useState(
    openInCustomOrderEditMode,
  )
  const [isDefaultListsVisible, setIsDefaultListsVisible] = useState(
    !openInCustomOrderEditMode,
  )

  const onCustomOrderModeEnable = () => {
    setIsCustomizeOrderModeActive(true)
    setIsDefaultListsVisible(false)
  }

  const onCustomOrderModeDisable = () => {
    setIsCustomizeOrderModeActive(false)
    setIsDefaultListsVisible(true)
  }

  const onToggleDefaultListsVisibility = () => {
    setIsDefaultListsVisible((prev) => !prev)
  }

  const handleClickCreateOpenChatsList = () => {
    openDialog({
      type: DIALOG_TYPE.CREATE_OPEN_CHATS_LIST,
    })
  }

  return (
    <div
      className={classNames(
        'shrink-1 flex-1 overflow-hidden lg:max-w-[422px]',
        className,
      )}
    >
      <ListHeading
        sort={sort}
        order={order}
        setSort={setSort}
        setOrder={setOrder}
        sortOptions={sortOptions}
        orderOptions={orderOptions}
        query={query}
        setQuery={setQuery}
        isCustomizeOrderModeActive={isCustomizeOrderModeActive}
        onCustomOrderModeEnable={onCustomOrderModeEnable}
        onCustomOrderModeDisable={onCustomOrderModeDisable}
        saveCustomOrderChanges={saveCustomOrderChanges}
        isCustomOrderChangeLoading={isCustomOrderChangeLoading}
        isSortAndOrderDisabled={isSortAndOrderDisabled}
      />
      <div className="mt-2.5 h-[524px]">
        <ListContent
          lists={lists}
          isLoading={isLoading}
          canLoadMore={canLoadMore}
          onLoadMore={onLoadMore}
          isFetchingNextPage={isFetchingNextPage}
          onSelectListId={onSelectListId}
          isCustomizeOrderModeActive={isCustomizeOrderModeActive}
          onToggleDefaultListsVisibility={onToggleDefaultListsVisibility}
          isDefaultListsVisible={isDefaultListsVisible}
          onReorder={onReorder}
        />
      </div>
      <Button
        className="mt-4 w-full"
        onClick={handleClickCreateOpenChatsList}
      >
        <PlusIcon className="h-5 w-5" />
        Create Open Chats List
      </Button>
    </div>
  )
}
